import styled from 'styled-components';

export const ContactWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: stretch;
  border: 1px solid #e6eaf2;
  border-radius: 18px;
  padding: 24px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
  text-align: left;
  @media (max-width: 576px) {
    padding: 18px;
  }
  label {
    text-transform: capitalize;
    font-weight: 600;
    color: #0f172a;
  }
`;
export const ContactInputWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  align-items: center;
`;
export const Select = styled.select`
  padding: 0.575rem 0.75rem;
  border: 1px solid #d7deea;
  border-radius: 12px;
  background: #f8fafc;
  width: 100%;
  max-width: 160px;
  outline: none;
  &&:focus-visible {
    border-color: #2563eb;
    box-shadow: 0 0 0 3px rgb(37 99 235 / 20%);
  }
`;
export const ContactText = styled.div`
  padding-top: 8px;
  font-size: 13px;
  line-height: 1.6;
  color: #475569;
`;

export const UserContactWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 12px;
  width: 100%;
  align-items: center;
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
  .input-group {
    width: 100%;
    margin-bottom: 0;
  }
`;
export const LoginWrapper = styled.div`
  text-transform: capitalize;
  display: flex;
  margin-bottom: 20px;
`;
export const LoginText = styled.div`
  ${(props) => ` 
 color: ${props.textcolor};
  transition: 0.4s;
  &&:hover {
    color: ${props.texthvcolor};
  }
  cursor: pointer;
  margin-left: 10px;
`}
`;
